import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import UVBlockLandingV3 from "./pages/UVBlockLandingV3";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<UVBlockLandingV3 />} />
          <Route path="*" element={<UVBlockLandingV3 />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
